//現在の天気を取得する場所の名前
let targetCityName = "Aoba";
let appId = "dc8153d85c08b9d8b5a50d4660cdf8e2";
let weatherData

const requestUrl = "https://api.openweathermap.org/data/2.5/weather?APPID=" + appId + "&lang=en&units=metric&q=" + targetCityName + ",jp;";

/**
 * 今日の天気を表示する
 */
export async function showWeather() {

    if (weatherData == null && location.pathname == "/") {
        //Ajax通信用のオブジェクトを作成
        let xhr = new XMLHttpRequest();

        //通信方式とURLを設定
        xhr.open("GET", requestUrl);

        //通信を実行する
        xhr.send();

        //通信ステータスが変わったら実行される関数
        xhr.onreadystatechange = function () {
            //通信が完了
            if (xhr.readyState == 4) {
                weatherData = xhr.responseText;
            }
        }
    }

    if (weatherData != null && location.pathname == "/") {
        waitWeatherInfo()
    } else if (location.pathname == "/") {
        setTimeout(showWeather, 1000)
    }

    function waitWeatherInfo() {
        let obj = JSON.parse(weatherData);

        let today = document.querySelector(".mv__innerBlockToday")

        today.querySelector(".condition").innerHTML = obj.weather[0].description
        today.querySelector(".temp").innerHTML = Math.round(obj.main.temp)
        today.querySelector(".humi").innerHTML = obj.main.humidity
    }
}